// extracted by mini-css-extract-plugin
export default {"noBackground":"Ica-z","qnaContainer":"Jca-z","qna":"Kca-z","question":"Lca-z","modal":"Mca-z"};